import { useState, useCallback, useEffect } from "react";
import { useApi } from "../../api/hooks/useApi";
import { ApiError } from "../../api/ApiError";
import { getApiErrorMessage } from "../../utils/apiError";

export function useCourseById(courseId?: string) {
  const { request } = useApi();

  const [course, setCourse] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [errorStatusCode, setErrorStatusCode] = useState<number | undefined>(undefined);

  const fetchCourse = useCallback(async () => {
    if (!courseId) return;

    setLoading(true);
    setError(null);
    setErrorStatusCode(undefined);

    try {
      const res = await request(`api/courses/${courseId}`);

      const courseData = res?.course || res?.response || res;

      setCourse(courseData ?? null);
    } catch (err) {
      console.error("⚠️ Falha ao buscar curso por ID:", err);
      setError(getApiErrorMessage(err, "Falha ao buscar informações do curso"));
      setErrorStatusCode(err instanceof ApiError ? err.statusCode : undefined);
      setCourse(null);
    } finally {
      setLoading(false);
    }
  }, [courseId]);

  useEffect(() => {
    fetchCourse();
  }, [fetchCourse]);

  return {
    course,
    loading,
    error,
    errorStatusCode,
    refetch: fetchCourse,
  };
}